import React from "react"
import "./new-product-info.scss"
import { siteUrl } from "../../../shared/utils/siteUrl"

const handleRedirectVConfident = () => {
  if(localStorage.getItem("USER_INFO") !== null){
    localStorage.setItem('openModalLogin',true)
  }
}

const NewProductInfo = ({haveTrackSample}) => {
  return (
    <div className="f-new-product-info">
      <div className="f-new-product-info__wrapper">
        <p className="f-new-product-info__name">
          Nueva Nosotras V-Confident
          <span> para tu etapa adulta. </span>
        </p>
        <a
          className="f-new-product-info__link"
          onClick={ () => handleRedirectVConfident()}
          href={
            siteUrl + "/v-confident/" + (
              typeof window !== 'undefined' && localStorage.getItem("USER_INFO") !== null
              ? "muestra-gratis"
              : ""
            )}
        >
          {haveTrackSample ? (
            <>
              ¡Pide tu muestra gratis aquí!
            </>
          ) : (
            <>
              ¡Conoce más aquí!
            </>

          )}
        </a>
      </div>
    </div>
  )
}

export default NewProductInfo
